import { lazy } from 'react';
import { IA_KEY } from 'helpers/ia-logic';

import {
  handleRouteEnter as handleReservationsReportRouteEnter,
  watchActions as watchReservationsReportActions,
} from './Reservations/Reservations.saga';
import {
  handleRouteEnter as handleCampaignsReportRouteEnter,
  watchActions as watchCampaignsReportActions,
} from './Campaigns/Campaigns.saga';
import {
  handleRouteEnter as handleSchedulesReportRouteEnter,
  watchActions as watchSchedulesReportActions,
} from './Schedules/Schedules.saga';
import { handleRouteEnter as handleScheduleReportRouteEnter } from './Schedule/Schedule.saga';
import {
  handleRouteEnter as handleVenuesReportRouteEnter,
  watchActions as watchVenuesReportActions,
} from './Venues/Venues.saga';
import {
  watchActions as watchPayoutTransactionActions,
  handleRouteEnter as handlePayoutTransactionRouteEnter,
} from './PayoutTransaction/PayoutTransaction.saga';
import { handleRouteEnter, watchActions, watchCSVActions } from './Stats.saga';
import { STATS_TAB_TYPES, VENUES_REPORTS_TYPES } from './Stats.constants';
import { SkuPayoutReportsList, SkuPayoutReportDetail } from '../Sku/PayoutReports';

const ReservationsReport = lazy(() =>
  import(/* webpackChunkName: "stats-reservations" */ './Reservations').then(m => ({ default: m.ReservationsReport }))
);
const CampaignsReport = lazy(() =>
  import(/* webpackChunkName: "stats-campaigns-report" */ './Campaigns').then(m => ({ default: m.CampaignsReport }))
);
const SchedulesReport = lazy(() =>
  import(/* webpackChunkName: "stats-schedules" */ './Schedules').then(m => ({ default: m.SchedulesReport }))
);
const ScheduleReport = lazy(() =>
  import(/* webpackChunkName: "stats-schedule" */ './Schedule').then(m => ({ default: m.ScheduleReport }))
);
const VenuesReport = lazy(() =>
  import(/* webpackChunkName: "stats-venues" */ './Venues').then(m => ({ default: m.VenuesReport }))
);
const PayoutTransaction = lazy(() =>
  import(/* webpackChunkName: "stats-payout-transaction" */ './PayoutTransaction').then(m => ({
    default: m.PayoutTransaction,
  }))
);
const MonthlyReports = lazy(() => import(/* webpackChunkName: "stats-monthly" */ './MonthlyReports/MonthlyReports'));
const PayoutDetails = lazy(() =>
  import(/* webpackChunkName: "stats-payout-details" */ './PayoutDetails/PayoutDetailsContainer')
);
const Stats = lazy(() => import(/* webpackChunkName: "stats-main" */ './StatsContainer'));

export default [
  {
    path: '/stats/reports/bookings',
    component: ReservationsReport,
    iaKey: IA_KEY.STATS_REPORTS_BOOKINGS,
    pathSagas: [watchCSVActions, watchReservationsReportActions, handleReservationsReportRouteEnter],
    hideVenueSelector: true,
  },
  {
    path: '/stats/reports/classes/:scheduleId',
    component: ScheduleReport,
    pathSagas: [handleScheduleReportRouteEnter],
    hideVenueSelector: true,
  },
  {
    path: '/stats/reports/classes',
    component: SchedulesReport,
    pathSagas: [watchCSVActions, watchSchedulesReportActions, handleSchedulesReportRouteEnter],
    hideVenueSelector: true,
  },
  {
    path: '/stats/reports/campaigns',
    component: CampaignsReport,
    iaKey: IA_KEY.CAMPAIGNS,
    pathSagas: [handleCampaignsReportRouteEnter, watchCampaignsReportActions],
    hideVenueSelector: false,
  },
  {
    path: '/stats/reports/payouts/orders',
    component: SkuPayoutReportsList,
    iaKey: IA_KEY.SKU_PAYOUT_REPORTS,
    pathSagas: [],
    hideVenueSelector: true,
  },
  {
    path: '/stats/reports/payouts/orders/:payoutId',
    component: SkuPayoutReportDetail,
    iaKey: IA_KEY.SKU_PAYOUT_REPORTS,
    pathSagas: [],
    hideVenueSelector: true,
  },
  {
    path: '/stats/reports/payouts/:transactionType/:payoutId',
    component: PayoutTransaction,
    pathSagas: [watchPayoutTransactionActions, handlePayoutTransactionRouteEnter],
    hideVenueSelector: true,
  },
  // we only permission gate the reports with revenue info
  {
    path: `/stats/reports/:venuesReportType`,
    component: VenuesReport,
    iaKey: ({ venuesReportType }) =>
      venuesReportType === VENUES_REPORTS_TYPES.REVENUE ? IA_KEY.STATS_REPORTS_VENUE_REVENUE : undefined,
    pathSagas: [watchVenuesReportActions, handleVenuesReportRouteEnter],
    hideVenueSelector: true,
  },
  {
    path: '/stats/reports/payout-details',
    component: PayoutDetails,
    hideVenueSelector: true,
    pathSagas: [watchActions],
  },
  {
    path: '/stats/reports/monthly',
    component: MonthlyReports,
    hideVenueSelector: true,
  },
  {
    path: `/stats/:venueId/:tab`,
    component: Stats,
    iaKey: ({ tab }) => (tab === STATS_TAB_TYPES.MARKET_INSIGHTS ? IA_KEY.STATS_MARKET_INSIGHTS : undefined),
    pathSagas: [watchActions],
    locationSagas: [handleRouteEnter],
  },
  {
    path: '/stats/:tab',
    component: Stats,
    pathSagas: [watchActions, handleRouteEnter],
    hideVenueSelector: true,
  },
];
